import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import * as userSlice from '../../data/user.slice';
import { useHasPermission } from './useHasPermission';

export const useCanEditBankInfo = (): boolean => {
  const [canEditBankInfo, setCanEditBankInfo] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const editAllPermission: Permission = {
    resource: 'providers',
    action: 'updatebanking',
    scope: 'all',
  };
  const editProviderPermission: Permission = {
    resource: 'providers',
    action: 'updatebanking',
    scope: 'provider',
  };

  const canEditAll = useHasPermission(user, editAllPermission);
  const canEditProvider = useHasPermission(user, editProviderPermission);

  React.useEffect(() => {
    setCanEditBankInfo(canEditAll || canEditProvider);
  }, [canEditAll, canEditProvider]);

  return canEditBankInfo;
};
